import styled, { css } from 'styled-components';
import { popoverShadow, surface } from '../themeTokens';
import { CHROME_INSET_PX } from './chrome.constants';

export const ExpandSlot = styled.div<{ $standalone: boolean }>`
  position: absolute;
  ${(p) => (p.$standalone ? 'bottom' : 'top')}: ${CHROME_INSET_PX}px;
  right: ${CHROME_INSET_PX}px;
  z-index: 4;
  pointer-events: auto;
  ${(p) =>
    p.$standalone &&
    css`
      border-radius: 50%;
      background: ${surface};
      box-shadow: ${popoverShadow};
    `}
`;
